module.exports = __webpack_public_path__ + "img/gmc.f5fffce3.png";